import { assign } from "lodash";
import { ChangeDetectionStrategy, Component, ElementRef, signal, ViewChild } from "@angular/core";
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, FormControl } from '@angular/forms';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from "@medsurf/flat-facades";
import { ZodSharedValidator } from "@medsurf/flat-validators";

@Component({
    selector: 'medsurf-slide-edit-layer',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './layer.component.html',
    styleUrls: ['./layer.component.scss'],
    standalone: false
})
export class LayerComponent {
  @ViewChild('edit_overlay_template_scroll_panel', {static: false}) editPanelScrollPanel: ElementRef<HTMLDivElement>;
  
  #isSubmitted = signal(false);
  layer: FlatModels.LayerEntityModels.Layer;
  layerForm = new FormGroup(
    {
      window: new FormControl<FlatModels.LayerEntityModels.Window>(FlatModels.LayerEntityModels.Window.null),
    },
    {
      validators: ZodSharedValidator.validate(
        FlatModels.LayerEntityModels.LayerSchema.pick({
          window: true,
        })
      ),
      updateOn: 'change'
    }
  );
  readonly FlatModels = FlatModels;
  
  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public slideAuthorFacade: FlatFacades.SlideAuthorFacade) {
    // Update Layer
    this.slideAuthorFacade.currentSelectedSlideLayer$.pipe(takeUntilDestroyed()).subscribe((layer) => {
      if (this.layer?.id !== layer?.id && this.editPanelScrollPanel) {
        this.editPanelScrollPanel.nativeElement.scrollTop = 0;
      }
      this.layer = structuredClone(layer);
      if (this.layer) {
        this.layerForm.reset({
          window: this.layer.window !== null ? this.layer.window : FlatModels.LayerEntityModels.Window.null
        });
      }
      this.#isSubmitted.set(false);
    });
  }
  
  onSubmit() {
    if (this.#isSubmitted() || this.layerForm.invalid) {
      return;
    }
    this.#isSubmitted.set(true);
    
    // Update Layer
    const layer = assign(this.layer, {
      window: (this.layerForm.value.window === FlatModels.LayerEntityModels.Window.null ? null : this.layerForm.value.window)
    });
    this.slideAuthorFacade.requestUpdateLayer(layer, 'history.layer_update').subscribe({
      error: (result) => {
        ZodSharedValidator.handleError(result, this.alertControlFacade, this.layerForm);
        this.#isSubmitted.set(false);
      },
      next: () => {
        this.#isSubmitted.set(false);
      }
    });
  }
}
